<tt-select
  data-testid="language-picker_select"
  id="editor-header__authors-owner-input"
  [disabled]="disabled"
  [ngModel]="currentLanguage"
  (ngModelChange)="languageChanged.emit($event)">
  <tt-select-items>
    @for (language of languageStore.allLanguages$ | async; track language.code) {
      <tt-option [attr.data-testid]="'language-picker_' + language.code" [value]="language.code">
        {{ 'LanguagePicker.' + language.code | transloco }}
      </tt-option>
    }
  </tt-select-items>
</tt-select>
